import React, { useState } from "react";
import { Chip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import icon from "../../../../../../common/components/icon-component/icon";
import { translate } from "../../../../../../common/providers";
import styles from "./EmailTagInput.module.css";

export default function EmailTagInput({ emails, onChange, maxEmails = 5 }) {
	const [input, setInput] = useState("");
	const [error, setError] = useState(null);

	const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

	const handleKeyDown = (e) => {
		if (e.key === "Enter" || e.key === "Tab" || e.key === ",") {
			e.preventDefault();
			const email = input.trim().replace(/,$/, "");

			if (!email) {
				return;
			}

			if (!isValidEmail(email)) {
				setError(translate("common:multiple-email-input.error-message.not-valid") || "Invalid email");
				return;
			}

			if (emails.length >= maxEmails) {
				setError(
					translate("document-center.distribution-notification.emails.max-reached") ||
						`Max ${maxEmails} emails`
				);
				return;
			}

			if (emails.includes(email)) {
				setInput("");
				return;
			}

			onChange([...emails, email]);
			setInput("");
			setError(null);
		} else if (e.key === "Backspace" && !input && emails.length > 0) {
			onChange(emails.slice(0, -1));
		}
	};

	const handleDelete = (emailToDelete) => {
		onChange(emails.filter((email) => email !== emailToDelete));
	};

	const handleChange = (e) => {
		setInput(e.target.value);
		if (error) {
			setError(null);
		}
	};

	const handleBlur = () => {
		if (input.trim()) {
			const email = input.trim();
			if (isValidEmail(email) && emails.length < maxEmails && !emails.includes(email)) {
				onChange([...emails, email]);
				setInput("");
				setError(null);
			}
		}
	};

	return (
		<div className={styles.container}>
			<label className={styles.label} htmlFor="email-tag-input">
				{translate("document-center.distribution-notification.emails.label")}
				<span className={styles.hint}>
					{translate("document-center.distribution-notification.emails.placeholder")}
				</span>
			</label>
			<div className={`${styles.inputContainer} ${error ? styles.errorBorder : ""}`}>
				{emails.map((email) => (
					<Chip
						key={email}
						className={styles.chip}
						deleteIcon={<FontAwesomeIcon icon={icon.faXmark} />}
						label={email}
						size="small"
						onDelete={() => handleDelete(email)}
					/>
				))}
				{emails.length < maxEmails && (
					<input
						className={styles.input}
						id="email-tag-input"
						placeholder={
							emails.length === 0
								? translate("document-center.distribution-notification.emails.placeholder")
								: ""
						}
						value={input}
						onBlur={handleBlur}
						onChange={handleChange}
						onKeyDown={handleKeyDown}
					/>
				)}
			</div>
			{error && <span className={styles.errorMessage}>{error}</span>}
		</div>
	);
}
